import { render, staticRenderFns } from "./BpCheckboxesDropdown.vue?vue&type=template&id=5076cefd&scoped=true&"
import script from "./BpCheckboxesDropdown.vue?vue&type=script&lang=js&"
export * from "./BpCheckboxesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BpCheckboxesDropdown.vue?vue&type=style&index=0&id=5076cefd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5076cefd",
  null
  
)

export default component.exports